import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { OPERERROR, SAVESUCCESS } from 'src/app/tabms/tab-consts';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss'
})
export class UploadComponent implements OnDestroy{
  UploadfromExcel
  excelData: any[];
  excelHeaders: string[];
  serviceInstance

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data,
    private baseService: BaseService
  ) {
    this.UploadfromExcel = this.translate.instant('UploadfromExcel');
    this.serviceInstance = this.data.service

  }

  onFileChange(e) {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const arrayBuffer = e.target.result; // البيانات بصيغة ArrayBuffer
      const data = new Uint8Array(arrayBuffer); // تحويل إلى Uint8Array
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      console.log('Excel data:', this.excelData);
      this.extractHeaders();

    };
    reader.readAsArrayBuffer(file);  // استبدال readAsBinaryString بـ readAsArrayBuffer

  }

  extractHeaders() {
    if (this.excelData.length > 0) {
      this.excelHeaders = Object.keys(this.excelData[0]);
      console.log('Headers:', this.excelHeaders);
    }
  }

  uploadfile() {
    this.serviceInstance.createBulkData(this.excelData).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.baseService.showSuccessMessage(SAVESUCCESS);
      },
      error: (err) => {
        console.log(err);
        this.baseService.showErrorMessage(OPERERROR);
      }
    })
   }

   ngOnDestroy(): void {
     this.destroy$.next();
     this.destroy$.complete();
   }
}
